"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsBarPropNames = exports.NewsBarColor = void 0;
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
var NewsBarColor;
(function (NewsBarColor) {
    NewsBarColor["Black"] = "black";
    NewsBarColor["Blue"] = "blue";
    NewsBarColor["Brand"] = "brand";
    NewsBarColor["Gray"] = "gray";
    NewsBarColor["Green"] = "green";
    NewsBarColor["Custom"] = "custom";
})(NewsBarColor = exports.NewsBarColor || (exports.NewsBarColor = {}));
/**
 * This enum is needed for better TypeScript experience
 * within the `NewsBar.stories.ts` file.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 *
 * @see ./NewsBar.stories.ts
 */
var NewsBarPropNames;
(function (NewsBarPropNames) {
    NewsBarPropNames["Closable"] = "closable";
    NewsBarPropNames["Color"] = "color";
})(NewsBarPropNames = exports.NewsBarPropNames || (exports.NewsBarPropNames = {}));
//# sourceMappingURL=NewsBar.contracts.js.map